import React from 'react';
import { useStateContext } from '../contexts/ContextProvider';

const RiskProfileQuestions = ({ isOpen, onClose, answers }) => {
  const { currentMode } = useStateContext();
  
  if (!isOpen) return null;

  // answers is an array of { questionId, question, answer }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className={`rounded-lg p-6 max-w-2xl w-full ${currentMode === 'Dark' ? 'bg-secondary-dark-bg border border-gray-600' : 'bg-white'}`}>
        <div className="flex justify-between items-center mb-4">
          <h2 className={`text-xl font-bold ${currentMode === 'Dark' ? 'text-white' : 'text-gray-900'}`}>
            Risk Profile Questions & Answers
          </h2>
          <button
            type="button"
            onClick={onClose}
            className={`text-2xl font-bold hover:opacity-70 transition-opacity ${currentMode === 'Dark' ? 'text-gray-300 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="overflow-y-auto max-h-[60vh]">
          <table className={`min-w-full divide-y ${currentMode === 'Dark' ? 'divide-gray-600' : 'divide-gray-200'}`}>
            <thead>
              <tr>
                <th className={`px-4 py-2 text-left text-xs font-medium uppercase ${currentMode === 'Dark' ? 'text-gray-300' : 'text-gray-500'}`}>
                  Question
                </th>
                <th className={`px-4 py-2 text-left text-xs font-medium uppercase ${currentMode === 'Dark' ? 'text-gray-300' : 'text-gray-500'}`}>
                  Answer
                </th>
              </tr>
            </thead>
            <tbody>
              {answers.map((ans, idx) => (
                <tr key={ans.questionId || idx} className={currentMode === 'Dark' ? 'hover:bg-secondary-dark-bg-light' : 'hover:bg-gray-50'}>
                  <td className={`px-4 py-2 text-sm ${currentMode === 'Dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                    {ans.question}
                  </td>
                  <td className={`px-4 py-2 text-sm font-semibold ${currentMode === 'Dark' ? 'text-white' : 'text-gray-900'}`}>
                    {ans.answer}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RiskProfileQuestions; 